export default __webpack_public_path__ + "static/media/INK.92a73a83.png";